import {
  ButtonLoader,
  ButtonWithPromise,
  ButtonWithPromiseProps
} from './index';

export type GradientButtonWithPromiseProps<T> = ButtonWithPromiseProps<T> & {
  gradient?: string;
  borderWidth?: number;
  borderRadius?: number;
  isLoading?: boolean;
};

export const GradientButtonWithPromise = <T extends any>({
  gradient = 'linear-gradient(160deg, #6AB2FB 2%, #BB6BD9 87%)',
  borderWidth = 2,
  borderRadius = 8,
  isLoading,
  style,
  disabled,
  pending,
  children,
  startIcon,
  ...props
}: GradientButtonWithPromiseProps<T>) => {
  return (
    <div
      style={{
        display: 'inline-block',
        padding: borderWidth,
        borderRadius: borderRadius,
        background: gradient
      }}
    >
      <ButtonWithPromise
        {...props}
        pending={pending}
        disabled={disabled || isLoading}
        startIcon={!isLoading && startIcon} // Hide icon when loading externally
        style={{
          borderRadius: borderRadius - borderWidth,
          background: '#fff',
          fontWeight: 'bolder',
          ...style
        }}
      >
        {isLoading ? (
          <>
            <ButtonLoader /> {pending}
          </>
        ) : (
          children
        )}
      </ButtonWithPromise>
    </div>
  );
};
